import { createFileRoute, useSearch } from "@tanstack/react-router";
import { z } from "zod";

import type { RouterContextType } from "@/api/permissions/permissions.api";
import { MODULE_KEYS_MAP } from "@/api/permissions/permissions.types";
import { CreateRequestWizard } from "@/components/features/Procurement/design/CreateRequestWizard";
import { useBreadcrumb } from "@/hooks/useBreadcrumb";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { getRouteIcon } from "@/utils/getRouteIconComponent";

const newRequestSearchSchema = z.object({
  wo: z.string().optional().catch(undefined),
  /** Preselects the request type, so a link can land on picking the item rather than the type. */
  type: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_authenticated/procurement/new")({
  component: NewProcurementRequestPage,
  validateSearch: newRequestSearchSchema.parse,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function NewProcurementRequestPage() {
  const { wo, type } = useSearch({ from: "/_authenticated/procurement/new" });

  useBreadcrumb([
    {
      title: "Procurement Queue",
      href: "/procurement",
      icon: getRouteIcon(MODULE_KEYS_MAP.procurement),
    },
    { title: "Create Request", href: "/procurement/new" },
  ]);

  return (
    <CreateRequestWizard
      key={`${wo ?? "blank"}-${type ?? "any"}`}
      initialWo={wo}
      initialType={type}
    />
  );
}
